export default class LlmConversationMessage {
    /**
     * @constructor
     * @param {string} sender 
     * @param {string} message 
     */
    constructor(sender, message) {
        this._sender = sender;
        this._message = message;
    }

    get sender() {
        return this._sender;
    }

    get message() {
        return this._message;
    }

    toObject() {
        return {
            role: this._sender,
            content: this._message
        };
    }

    static fromObject(json) {
        return new LlmConversationMessage(json.role, json.content);
    }
}

export const LlmMessageSender = {
    ASSISTANT: 'assistant',
    USER: 'user',
};